<div class="my-4" [ngClass]="exibirNovaRecarga ? '' : 'mx-5'">
    <!-- <div class="wrapper mb-2"> -->
        <ng-container *ngIf="exibirNovaRecarga && !exibirRecargaArquivo">
            <sv-new-purchase></sv-new-purchase>
        </ng-container>
        <ng-container *ngIf="!exibirNovaRecarga || exibirRecargaArquivo">
            <router-outlet></router-outlet> 
        </ng-container>  
    <!-- </div> -->
    
</div>
